export function lsGet(key, fallback = null) {
  try { const v = localStorage.getItem(key); return v !== null ? JSON.parse(v) : fallback; }
  catch { return fallback; }
}
export function lsSet(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch { /* private browsing */ }
}
export function ssGet(key) { try { return sessionStorage.getItem(key); } catch { return null; } }
export function ssSet(key, val) { try { sessionStorage.setItem(key, val); } catch {} }
export function ssRemove(key) { try { sessionStorage.removeItem(key); } catch {} }
